import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Snackbar, Alert } from '@mui/material'

const NotificationHandler = () => {
    const location = useLocation()
    const [notification, setNotification] = useState(null)
    const [open, setOpen] = useState(false)

    useEffect(() => {
        // Check for notification in location state
        if (location.state?.notification) {
            const { notification: newNotification } = location.state
            
            // Only show if it's a recent notification (within last 5 seconds)
            const isRecent = Date.now() - newNotification.timestamp < 5000
            
            if (isRecent) {
                setNotification(newNotification)
                setOpen(true)
                
                // Clear the state to prevent showing again on refresh
                const currentState = window.history.state?.state || {}
                window.history.replaceState(
                    { ...currentState, notification: null }, 
                    ''
                )
            }
        }
    }, [location])

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return
        }
        setOpen(false)
    }

    const handleExited = () => {
        setNotification(null)
    }

    return (
        <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
            onExited={handleExited}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
            <Alert 
                onClose={handleClose} 
                severity={notification?.type || 'info'}
                variant="filled"
                sx={{ width: '100%' }}
            >
                {notification?.text}
            </Alert>
        </Snackbar>
    )
}

export default NotificationHandler

